import { ETaxSourceType, IPageParam } from '@core/main/types/common';

/**
 * 开票科目树查询请求参数
 */
export interface IInvoiceSubjectTreeRequest {
  /** 开票科目类型(0服务商) */
  invoiceSubType?: number;
}

/**
 * 开票科目树节点
 */
export interface IInvoiceSubjectTreeNode {
  /** 主键id */
  id: number;
  /** 父级id */
  parentId: number;
  /** 开票科目名称 */
  invoiceSubName: string;
  /** 父级开票科目名称 */
  parentInvoiceSubName: string;
  /** 开票科目级别(0大类 1小类) */
  level: number;
  /** 开票科目类型(0服务商) */
  invoiceSubType: number;
  /** 下一级开票科目 */
  children?: IInvoiceSubjectTreeNode[];
}

/**
 * 新增开票科目请求参数
 */
export interface IInvoiceSubjectAddRequest {
  /** 开票科目名称 */
  invoiceSubName: string;
  /** 父类ID */
  parentId: number;
  /** 开票科目级别(0大类 1小类) */
  level: number;
}

/**
 * 新增开票科目响应
 */
export interface IInvoiceSubjectAddResponse {
  /** 响应码 */
  code: number;
  /** 响应内容 */
  context: Record<string, never>;
  /** 响应消息 */
  message?: string;
}

/**
 * 删除开票科目请求参数
 */
export interface IInvoiceSubjectDeleteRequest {
  /** 开票科目ID */
  id: number;
}

/**
 * 删除开票科目响应
 */
export interface IInvoiceSubjectDeleteResponse {
  /** 响应码 */
  code: number;
  /** 响应内容 */
  context: Record<string, never>;
  /** 响应消息 */
  message?: string;
}

/**
 * 编辑开票科目请求参数
 */
export interface IInvoiceSubjectEditRequest {
  /** 开票科目ID */
  id: number;
  /** 开票科目名称 */
  invoiceSubName: string;
}

/**
 * 编辑开票科目响应
 */
export interface IInvoiceSubjectEditResponse {
  /** 响应码 */
  code: number;
  /** 响应内容 */
  context: Record<string, never>;
  /** 响应消息 */
  message?: string;
}

export interface IInvoiceLibraryParams extends IPageParam{
  /** 开票科目库ID */
  id?: number;
  /** 类型(0通用 1海南) */
  type?: ETaxSourceType;
  /** 更新人ID */
  updaterId?: string;
  /** 更新时间开始 */
  updateTimeStart?: string;
  /** 更新时间结束 */
  updateTimeEnd?: string;
}

export interface IInvoiceLibraryItem {
  /** 开票科目库名称 */
  name: number;
  /** 类型(0通用 1海南) */
  type: ETaxSourceType;
  /** 更新人 */
  updater: string;
  /** 说明 */
  remark: string;
  /** 更新时间 */
  updateTime: string;
}

export const invoiceLibraryTaxSourceTypeConfig = {
  [ETaxSourceType.Hainan]: '海南',
  [ETaxSourceType.Mainland]: '通用',
};

export const invoiceLibraryTaxSourceTypeStyle = {
  [ETaxSourceType.Hainan]: 'primary',
  [ETaxSourceType.Mainland]: 'success',
};

export interface IInvoiceLibraryListItem {
  id: number;
  createTime: string;
  updateTime: string;
  creator: string;
  updater: string;
  deleted: boolean;
  /** 开票科目库名称 */
  name: number;
  /** 类型(0通用 1海南) */
  type: ETaxSourceType;
  /** 说明 */
  remark: string;
  /** 更新人ID */
  updaterId: string;
}
